import { createStore } from 'zustand'
import { persist } from 'zustand/middleware'

import type { StorageOptions } from '../localAndUrlStorage'
import { createLocalAndUrlStorage } from '../localAndUrlStorage'
import * as storageOptions from './storageOptions'
import type { DateRange, Filter, FiltersStore, PersistedState } from './types'

export const createFiltersStore = (
  contextId: string,
  withSearchParams: boolean = false,
) => {
  return createStore<FiltersStore>()(
    persist(
      (set) => ({
        filters: [],
        dateRanges: {},
        searchQuery: '',

        actions: {
          setFilters: (filters: Filter[]) => set({ filters }),

          addFilter: (filter: Filter) =>
            set((state) => ({ filters: [...state.filters, filter] })),

          updateFilter: (filterId: string, updates: Partial<Filter>) =>
            set((state) => ({
              filters: state.filters.map((f) =>
                f.id === filterId ? { ...f, ...updates } : f,
              ),
            })),

          removeFilter: (filterId: string) =>
            set((state) => ({
              filters: state.filters.filter((f) => f.id !== filterId),
            })),

          clearFilters: () => set({ filters: [] }),

          setDateRange: (dateRanges: DateRange | string) => set({ dateRanges }),
          clearDateRange: () => set({ dateRanges: {} }),

          setSearchQuery: (searchQuery: string) => set({ searchQuery }),
          clearSearchQuery: () => set({ searchQuery: '' }),
        },
      }),
      {
        name: `militao-${contextId}-filter-store`,
        partialize: (state) => ({
          filters: state.filters,
          dateRanges: state.dateRanges,
          searchQuery: state.searchQuery,
        }),
        ...(withSearchParams && {
          storage: createLocalAndUrlStorage<PersistedState>(
            storageOptions as StorageOptions<PersistedState>,
          ),
        }),
      },
    ),
  )
}
